module.exports = __webpack_public_path__ + "static/media/logolargewhite.d22d3352.png";